import { type FC, type MouseEventHandler } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { alpha, IconButton, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface CloseButtonProps {
  readonly onClick: MouseEventHandler<HTMLButtonElement>
  readonly sx?: SxProps<Theme>
}

export const CloseButton: FC<CloseButtonProps> = ({ onClick, sx }) => {
  const theme = useTheme()

  return (
    <IconButton
      onClick={onClick}
      size="small"
      aria-label="Close"
      sx={[closeButtonSx(theme), ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  )
}

const closeButtonSx = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.error.main,
  width: 32,
  height: 32,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.08),
  },
})
